/**
 * Theme JS entry — imports all module chunks from assets/js/modules/.
 * Add scripts in the matching module folder, then run: npm run build
 */
import initAnimations, {
	initImageRevealAnimation,
	initCampaignImageAnimation,
	initBottomLotusAnimation,
	initFooterFlowersAnimation,
	initFooterFlowerAnimation,
	initArrowAnimation,
	initBannerAnimation,
	initVoicesLotusAnimation,
	initResourcespageLotusAnimation,
	initHowtojoinLotusAnimation,
	initArtworkFormSection,
	initArtworksCardAnimation,
	initResourcesCardAnimation,
	initVoicesWelcomeAnimation,
	initNotAloneAnimation,
	initgetinvlovedanimations
} from './modules/animations/index.js';
import initCore from './modules/core/index.js';
import initFilters from './modules/filters/index.js';
import initForms from './modules/forms/index.js';
import initNavigation from './modules/navigation/index.js';
import initSearch from './modules/search/index.js';
import initUi from './modules/ui/index.js';
import initCarousel from './modules/carosuel/index.js';
import initImageCardSlider from './modules/image-card-slider/index.js';
import initMobileMenu from './modules/mobile-menu/index.js';
import initHopeBoard from './modules/hope-board/index.js';
import initHopeBento from './modules/hope-bento/index.js';
import initLenis from './modules/lenis/index.js';

const modules = [
	initLenis, // smooth scroll before ScrollTrigger-driven modules
	initCore,
	initAnimations,
	initNavigation,
	initForms,
	initFilters,
	initSearch,
	initUi,
	initCarousel,
	initImageCardSlider,
	initMobileMenu,
	initHopeBoard,
	initHopeBento,
	initImageRevealAnimation,
	initCampaignImageAnimation,
	initBottomLotusAnimation,
	initFooterFlowersAnimation,
	initFooterFlowerAnimation,
	initArrowAnimation,
	initBannerAnimation,
	initVoicesLotusAnimation,
	initResourcespageLotusAnimation,
	initHowtojoinLotusAnimation,
	initArtworkFormSection,
	initArtworksCardAnimation,
	initResourcesCardAnimation,
	initVoicesWelcomeAnimation,
	initNotAloneAnimation,
	initgetinvlovedanimations
];

document.addEventListener( 'DOMContentLoaded', () => {
	console.log('MAIN JS LOADED');
	modules.forEach( ( init ) => {
		if ( typeof init !== 'function' ) {
			return;
		}

		try {
			init();
		} catch ( error ) {
			console.error( 'Theme module failed to init:', error );
		}
	} );
} );
